import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../ts/Glob';
import { ProgressBar } from '../../../../_common/platform/tsx/ProgressBar';
import { getDirContentFromHash, isFolderLoading } from '../../ts/stores/WorkspacesDirsStore';
import DirsWorkspaceItem from '../DirsWorkspaceItem';
import { ISection } from '../../ts/stores/WorkspacesNavStore';
import * as permissions from '../../../../_common/platform/ts/permissions';

import { MenuItemTypes, IMenuBranch, MenuModes, TreeModes, FAVORITES } from './Common';

import { SidebarMenuItem, HorizontalMenuItem } from './WorkspacesNavigationItems';

interface IWorkspacesSectionProperties {
    instanceID: string;
    folderID: string | number;
    sectionType: MenuItemTypes;
    hideIcons: boolean;
    menuMode: MenuModes;
    glob: IGlob;

    onSelect(wsID: number): void;
    onShowActions(): void;
    onHideActions(): void;
}

export function WorkspacesSection(props: IWorkspacesSectionProperties) {
    const [updateKey, setUpdateKey] = React.useState({});

    React.useEffect(() => {
        const handleOnStoreChange = () => {
            setUpdateKey({});
        };

        props.glob.WorkspacesDirsStore.addChangeListener(handleOnStoreChange);
        props.glob.AppActions.workspacesExplorerSingleLoad(props.folderID, props.instanceID);

        return () => {
            props.glob.WorkspacesDirsStore.removeChangeListener(handleOnStoreChange);
        };
    }, []);

    const getWorkspaceClickHanlder = (wsid: number) => {
        return (e) => {
            if (typeof props.onSelect === 'function') {
                props.onSelect(wsid);
            }
        };
    };

    const store = props.glob.WorkspacesDirsStore.getInstanceState(props.instanceID);

    if (isFolderLoading(props.folderID, store.loadingFolders)) {
        return <ProgressBar />;
    }

    const dirContent = getDirContentFromHash(props.folderID, store.dirContentHash);

    let content;

    if (dirContent == null || dirContent.length === 0) {
        content = <div className="navigation-section no-workspace-item"></div>;
    } else {
        const favouritesOrigin = props.sectionType === FAVORITES;
        const isFavourite = props.folderID === FAVORITES;
        const allowEditing = permissions.canEdit();

        content = _.map(dirContent, (item, i) => {
            return (
                <div className="navigation-section" key={i}>
                    <DirsWorkspaceItem
                        key={item.wsid}
                        instanceID={props.instanceID}
                        wsid={item.wsid}
                        name={item.name}
                        displayDirId={props.folderID}
                        isFavourite={isFavourite}
                        favouritesOrigin={favouritesOrigin}
                        allowEditing={allowEditing}
                        changingWorkspaces={store.changingWorkspaces}
                        hideIcons={props.hideIcons}
                        menuMode={props.menuMode}
                        glob={props.glob}
                        onSelect={getWorkspaceClickHanlder(item.wsid)}
                        onShowActions={props.onShowActions}
                        onHideActions={props.onHideActions}
                    />
                </div>
            );
        });
    }

    return <div className="workspaces-section">{content}</div>;
}

interface IFolderSectionProperties {
    value: IMenuBranch[];
    menuMode: MenuModes;
    hideIcons: boolean;
    expandMenuOnMouseOver: boolean;
    treeMode: TreeModes;
    currentSection: ISection;
    glob: IGlob;

    getSectionContent(value: IMenuBranch): any;

    onSelect(value: IMenuBranch): void;
    onShowActions(): void;
    onHideActions(): void;
}

export function FoldersSection(props: IFolderSectionProperties) {
    const { value } = props;

    if (value == null || value.length === 0) {
        return null;
    }

    const content = _.map(value, (menuItem) => {
        if (props.menuMode === MenuModes.horizontal) {
            return (
                <HorizontalMenuItem
                    key={'dir_' + menuItem.id}
                    value={menuItem}
                    isSubItem={true}
                    hideIcons={props.hideIcons}
                    expandOnMouseOver={props.expandMenuOnMouseOver}
                    treeMode={props.treeMode}
                    glob={props.glob}
                    getItems={props.getSectionContent}
                    onClick={props.onSelect}
                    onShowActions={props.onShowActions}
                    onHideActions={props.onHideActions}
                />
            );
        } else {
            return (
                <SidebarMenuItem
                    key={'dir_' + menuItem.id}
                    value={menuItem}
                    hideIcons={props.hideIcons}
                    glob={props.glob}
                    getItems={props.getSectionContent}
                    onClick={props.onSelect}
                />
            );
        }
    });

    return <div className="folder-section">{content}</div>;
}
